<template>
  <div class="channels">
    
    <b-button-group class="float-right mt-3">
      <input-button
        @click="selectAll()"
        btnStyle="link-style"
        pointable
        variant="plainText"
        :inputPlaceholder="$t('Button.selectAll')" />

      <input-button
        @click="deselectAll()"
        btnStyle="link-style"
        pointable
        variant="plainText"
        :inputPlaceholder="$t('Button.unselectAll')" />
    </b-button-group>

    <!-- Schedule editor -->
    <!-- <campaign-se
      v-if="channelRefName"
      :channelParams="getEditDayEvents"
      @setSchedule="setSchedule" /> -->

    <!-- All available channels -->
    <div
      v-for="group in getConnectedChannelNames"
      :key="group"
      class="channel-group container p-0 m-0">
    
      <div class="spacer-subsection d-none d-md-block" />
      <div class="spacer-subsection-smaller d-block d-md-none" />

      <h5 class="channel-category-label">
        {{ $t(expandName(group)) }}
      </h5>

      <channel
        v-for="board in getChannelParams(group).boards || []"
        :key="board.identity"
        class="col m-0 p-0"
        
        :label="getBoardLabel(board.type, board)"
        :uuid="`${group}_${board.identity}`"
        :identity="board.identity"
        :connected="getChannelParams(group).connected"
        :channelName="group"
        :channelIcon="getChannelParams(group).icon"
        :ref="`${group}_${board.identity}`"
        :selected="isSelected(board.identity)"

        @channelSelected="channelSelected"
        @requestSchedualeEdit="requestSchedualeEdit" />

    </div>

    <!-- All not connected channels -->
    <div
      v-for="group in getNotConnectedChannelNames"
      :key="group"
      class="channel-group container p-0 m-0">
    
      <div class="spacer-subsection d-none d-md-block" />
      <div class="spacer-subsection-smaller d-block d-md-none" />

      <h5 class="channel-category-label">
        {{ $t(expandName(group)) }}
      </h5>

      <channel
        class="col m-0 p-0"

        :uuid="group"
        :falseUnconnected="isFalseUnconnected(group)"
        :connected="getChannelParams(group).connected"
        :channelName="group"
        :channelIcon="getChannelParams(group).icon"
        :ref="group"
        :selected="false"

        @channelSelected="channelSelected"
        @requestSchedualeEdit="requestSchedualeEdit" />

    </div>
  </div>
</template>

<script>
import InputButton from '@/components/standard/input/InputButton'
import InputCheckbox from '@/components/standard/input/InputCheckbox'
import objectHelpers from '@/assets/modules/objectHelpers'
import Channel from '@/components/standard/channels/Channel'
import CampaignScheduleEditor from '@/components/service/campaignManager/CampaignScheduleEditor'
import paramExtractor from '@/assets/modules/channels/paramExtractor'
import connectionHelper from '@/assets/modules/channels/connectionHelper'
import moment from 'moment'
import uuidv1 from 'uuid/v1'
import lsh from '@/assets/modules/localStorageHelper'

const IGNORED_CHANNELS = {
  wooCommerceShop: true,
  shopifyShop: true,
  shopamineShop: true
}

export default {
  data () {
    return {
      editDayEvents: {},
      selectedChannels: this.initialSelection,

      channelRefName: null,
      uuidv1
    }
  },

  methods: {
    /**
     * Selects all connected channels
     */
    selectAll () {
      this.runAllBoards(true)
    },

    /**
     * Deselects all connected channels
     */
    deselectAll () {
      this.runAllBoards(false)
    },

    /**
     * Loops all connected boards with given connected status
     * @param {Boolean} selected
     */
    runAllBoards (selected) {
      for (let channel of this.getConnectedChannels) {
        if (!IGNORED_CHANNELS[channel.name]) {
          for (let board of channel.boards) {
            let e = {
              channel: channel.name,
              identity: board.identity,
              selected
            }
  
            this.channelSelected(e)
          }
        }
      }
    },

    /**
     * Tells if channel is selected
     * @param {String} id
     * @returns {Boolean}
     */
    isSelected (id) {
      return !!this.selectedChannels[id]
    },

    /**
     * Returns a label for the given board
     * @param {Object} board
     * @returns {String}
     */
    getBoardLabel (type, board) {
      let label = board.label || (board.meta || {}).name || board.identity
      // Identity is a fallback label
      return paramExtractor.removeInformacijaPrefix(type, label)
    },

    /**
     * Gives the original channel object for that group
     * @param {String} group
     * @returns {Object}
     */
    getChannelParams (group) {
      return this.grouppedChannels[group] || {}
    },

    /**
     * Gives a full channel board name
     * @param {String} type
     */
    expandName (type) {
      return paramExtractor.extract(type).label
    },

    /**
     * Sets schedule for given channel board - stores in it self-
     * @param {Object} e
     */
    // setSchedule (e) {
    //   try {
    //     this.$refs[this.channelRefName][0].setDayEvents(e.events)
    //   } catch (e) {
    //     console.error(e)
    //   }

    //   this.channelRefName = null
    // },

    /**
     * Requests schedule edit for given channel board
     * @param {Object} e Board to reschedule
     */
    requestSchedualeEdit (e) {
      // this.channelRefName = e.refName
      // this.$set(this, 'editDayEvents', e)
    },

    /**
     * Emits channel selection change
     * @param {Object} e Selected channel
     */
    channelSelected (e) {
      if (!e.selected) {
        this.$delete(this.selectedChannels, e.identity)
      } else {
        this.$set(this.selectedChannels, e.identity, e.channel)
      }

      this.$emit('updateChannelList', {
        channels: this.selectedChannels,
        changed: {
          channel: e.channel,
          selected: e.selected,
          identity: e.identity
        }
      })
    },

    /**
     * Filteres ignored credetncredentials
     * @param {Array} credentials
     * @returns {Array}
     */
    filterIgnoredCredentials (credentials) {
      return credentials.filter(c => !IGNORED_CHANNELS[c])
    },

    /**
     * Tells if given channel appears unconnected, because all boards
     * are invisible
     * @param {String} channel
     * @returns {Boolean}
     */
    isFalseUnconnected (channel) {
      return connectionHelper.isFalseUnconnected(channel, this.invisibleChannels)
    },

    filterDisabledChannels (channels) {
      let filterOut = { 
        'sqwizPage': true,
        'wordpressWebsite': true,
        'wordpressUser': true,
        'informacijaShop': true 
      }
      channels = channels.filter(gn => !filterOut[gn.name])
      return channels
    }
  },

  computed: {
    /**
     * Gives a list of not connected channels
     * @returns {Array}
     */
    getNotConnectedChannels () {
      return Object.values(this.grouppedChannels).filter(gc => !gc.connected)
    },

    /**
     * GIves a list of not connected channel names
     * @returns {Array}
     */
    getNotConnectedChannelNames () {
      let notConnectedChannels = this.getNotConnectedChannels
      if(lsh.getData('interface', 'language') !== 'sl_SI') {
        notConnectedChannels = this.filterDisabledChannels(notConnectedChannels)
      }
      return this.filterIgnoredCredentials(notConnectedChannels.map(cn => cn.name))
    },

    /**
     * Gives a list of connected channels
     * @returns {Array}
     */
    getConnectedChannels () {
      return Object.values(this.grouppedChannels).filter(gc => gc.connected)
    },

    /**
     * Gives a list of connected channel names
     * @returns {Array}
     */
    getConnectedChannelNames () {
      let connectedChannels = this.getConnectedChannels
      if(lsh.getData('interface', 'language') !== 'sl_SI') {
        connectedChannels = this.filterDisabledChannels(connectedChannels)
      }
      return this.filterIgnoredCredentials(connectedChannels.map(cn => cn.name))
    },

    /**
     * Gets channel event schedule
     * @returns {Object}
     */
    getEditDayEvents () {
      // let base = {
      //   startsAt: this.startsAt,
      //   expiresAt: this.expiresAt,
      //   postsPerUnit: 6,
      //   maxPerDay: 6
      // }

      // let extra = this.editDayEvents
      // return Object.assign(base, extra)
    }
  },

  props: {
    initialSelection: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    invisibleChannels: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    campaignType: {
      type: String,
      required: false,
      default: ''
    },

    grouppedChannels: {
      type: Object,
      required: false,
      default: () => {return {}}
    },

    startsAt: {
      type: String,
      required: false,
      default: null
    },
    expiresAt: {
      type: String,
      required: false,
      default: null
    },

    stripped: {
      type: Boolean,
      required: false,
      default: true
    },
    selectable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    'campaign-se': CampaignScheduleEditor,
    'channel': Channel,
    'input-checkbox': InputCheckbox,
    'input-button': InputButton
  },
}
</script>

<style scoped>
.spacer-subsection {
  margin-top: 64px;
}
.spacer-subsection-smaller {
  margin-top: 33px;
}

.channels {
  padding: 10px;
  margin: 10px;
}
.channel {
  margin: 10px;
  padding: 10px;
}
.channel-category-label {
  font-size: 16px;
  line-height: 19px;
  color: #353635;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/standard/channels/ChannelList.vue?ea3df990